import { Notice } from '../models/Notice';
import { NoticeReceiver } from '../models/NoticeReceiver';

class NotificationService {
  public search(notifications: NoticeReceiver[] | Notice[], text: string) {
    return notifications.filter(
      (notification) =>
        notification.subject
          .toLocaleLowerCase()
          .includes(text.toLocaleLowerCase()) ||
        notification.body.toLocaleLowerCase().includes(text.toLocaleLowerCase())
    );
  }
}

export default new NotificationService();
